/**
 * Toggle hamburger to close button on open menu
 *
 * ATTENTION: 'elementor/popup/show' was triggered twice.
 * Solution: Set pointer-events: none; in css when open!
 *
 * // I tried to get classname first but seems more complicated and instable
 * // const popupSettings = JSON.parse(instance.$element[0].dataset.elementorSettings);
 * // console.log( popupSettings.classes );
 * // console.log( instance.$element[0] );
 */
jQuery( document ).on( 'elementor/popup/show', (event, id, instance) => {

    // check if popup is menu popup
    const popupMenu = document.querySelector('.wan-popup-menu-main');
    if( popupMenu && popupMenu.getAttribute('id').includes(id)) {
        const hamburger = document.querySelector('#wan-hamburger');
        hamburger.classList.add('open');
        //console.log('elementor/popup/show', hamburger,  hamburger.classList );
    }
} );

jQuery( document ).on( 'elementor/popup/hide', ( event, id, instance ) => {

    // check if popup is menu popup
    const popupMenu = document.querySelector('.wan-popup-menu-main');
    if( popupMenu && popupMenu.getAttribute('id').includes(id)) {
        const hamburger = document.querySelector('#wan-hamburger');
        hamburger.classList.remove('open');
        //console.log( 'elementor/popup/hide', hamburger, hamburger.classList );
    }
} );